import HttpCliente from "servicios/HttpCliente";
import axios from "axios";
import getResponseError from "utils/getResponseError";


//FUNCION PARA NO PEDIR TOKEN DE SEGURIDAD EN LA PETICION
const instancia = axios.create();
instancia.CancelToken = axios.CancelToken;
instancia.isCancel = axios.isCancel;

export const ChtChatbotAccesoModel = {
    usuarioId: ''
};

export const ChatbotAccesoModel = {
    id: 0,
    nombreUsuario: '',
    usuarioId: '',
    habilitado: false
};

/**
 * POST method - Obtiene una lista paginada con todas las relaciones acceso usuario chatbot
 * @param {number} pagina N° de página a recuperar
 * @param {number} cantElementos Cantidad de elementos por página
 * @param {string} acceso Campo de búsqueda
 * @return {Promise} Promesa de obtención
 */
export const paginacionChtChatbotAcceso = (pagina, cantElementos, acceso = "") => {
    return new Promise((resolve, eject) => {
        HttpCliente.post("/ChtChatbotAcceso/report", {
            PageNumber: pagina,
            PageSize: cantElementos,
            Acceso: acceso,
        })
            .then((response) => {
                resolve([response, undefined, response.status]);
            })
            .catch(error => {
                const err = getResponseError(error);
                resolve([undefined, err, error.response?.status]);
            });
    });
};

/**
 * POST method - Crear una acceso de usuario a chatbot
 * @param {ChtChatbotAccesoModel} acceso acceso
 * @return {Promise} Promesa de creación
 */
export const crearChtChatbotAcceso = (acceso) => {
    return new Promise((resolve, eject) => {
        HttpCliente.post("/ChtChatbotAcceso", acceso)
            .then((response) => {
                resolve([response, undefined, response.status]);
            })
            .catch((error) => {
                const err = getResponseError(error);
                resolve([undefined, err, error.response?.status]);
            });
    })
}

/**
 * PUT method - Actualiza un acceso a chatbot
 * @param {ChtChatbotAccesoModel} acceso Acceso
 * @return {Promise} Promesa de actualización
 */
export const actualizarChtChatbotAcceso = (acceso) => {
    return new Promise((resolve, eject) => {
        HttpCliente.put("/ChtChatbotAcceso", acceso)
            .then((response) => {
                resolve([response, undefined, response.status]);
            })
            .catch(error => {
                const err = getResponseError(error);
                resolve([undefined, err, error.response?.status]);
            });
    });
};

/**
 * GET method - Obtiene el acceso a chatbot por usuario
 * @return {Promise} Promesa de obtención
 */
export const obtenerChtChatbotAcceso = () => {
    return new Promise((resolve, eject) => {
        HttpCliente.get("/ChtChatbotAcceso")
            .then((response) => {
                resolve([response, undefined, response.status]);
            })
            .catch((error) => {
                const err = getResponseError(error);
                resolve([undefined, err, error.response?.status]);
            });
    });
};